import About from './pages/About';
import Navbar from './components/Navbar';
import ContactUs from './pages/ContactUs';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Service from './pages/Service';
import Home from "./pages/Home";
import Impressum from './pages/Impressum';

const App = () => {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />}></Route>
        <Route path="/home" element={<Home />} />
        <Route path="/services" element={<Service />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/about" element={<About />} />
        <Route path="/impressum" element={<Impressum />} />
      </Routes>
    </Router>
  );
}

export default App;
